(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-cart-drawer"]) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-cart-drawer]');
    if (!section) return;

    var panel = section.querySelector('.cart-drawer__panel');
    var body = section.querySelector('[data-cart-body]');
    var footer = section.querySelector('[data-cart-footer]');
    var sectionId = 'custom-cart-drawer';

    /* Teardown tracking */
    var teardown = [];
    function on(target, event, handler, opts) {
      target.addEventListener(event, handler, opts);
      teardown.push(function() { target.removeEventListener(event, handler, opts); });
    }

    /* Scroll lock is handled centrally in layout/theme.liquid via a :has()
       rule that watches for `.cart-drawer-section[aria-hidden="false"]` and
       sets overflow:hidden on <html>+<body>. No JS work needed here —
       previously savedHtmlOverflow/savedBodyOverflow plus manual inline
       style writes; now pure CSS reactive to the aria-hidden attribute. */

    /* Focus trap */
    var FOCUSABLE = 'a[href]:not([tabindex="-1"]), button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';
    function trapTab(e) {
      if (e.key !== 'Tab') return;
      var nodes = panel.querySelectorAll(FOCUSABLE);
      if (!nodes.length) return;
      var first = nodes[0];
      var last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    var lastFocused = null;
    var isOpen = false;

    /* Phase 18 — inert background elements while drawer is open.
       Removes them from the focus order + AT tree so focus trap
       becomes implicit. Cleaner than tabindex=-1 hacks.

       The drawer's own <footer class="cart-drawer__footer"> matches
       the bare `footer` selector — filter out anything inside the
       drawer so the Proceed-to-Checkout button stays interactive. */
    function setBackgroundInert(on) {
      var nodes = document.querySelectorAll('main, .shopify-section-header, footer, .custom-footer-section');
      Array.prototype.forEach.call(nodes, function (el) {
        if (section.contains(el)) return;
        if (on) el.setAttribute('inert', '');
        else el.removeAttribute('inert');
      });
    }

    function openDrawer() {
      if (isOpen) return;
      isOpen = true;
      lastFocused = document.activeElement;
      section.setAttribute('aria-hidden', 'false');
      /* Sync the cart trigger's aria-expanded so screen readers announce
         "expanded" state. The trigger lives in custom-header.liquid. */
      var cartTrigger = document.querySelector('.custom-header__cart-link');
      if (cartTrigger) cartTrigger.setAttribute('aria-expanded', 'true');
      setBackgroundInert(true);
      /* Phase 21 — User Timing mark. Pair with cart-drawer-open-end
         on closeDrawer for dwell-time measures. */
      if (window.BettrMetrics) window.BettrMetrics.mark('cart-drawer-open');
      /* Wait for transition-ready state so focus doesn't jump before slide-in */
      window.requestAnimationFrame(function() {
        var firstFocus = panel.querySelector('.bettr-modal-close');
        if (firstFocus) firstFocus.focus();
      });
    }

    function closeDrawer() {
      if (!isOpen) return;
      isOpen = false;
      section.setAttribute('aria-hidden', 'true');
      var cartTrigger = document.querySelector('.custom-header__cart-link');
      if (cartTrigger) cartTrigger.setAttribute('aria-expanded', 'false');
      setBackgroundInert(false);
      if (lastFocused && typeof lastFocused.focus === 'function') {
        try { lastFocused.focus(); } catch (err) {}
      }
    }

    /* Close: click overlay / close button, Escape */
    on(section, 'click', function(e) {
      if (e.target.closest('[data-cart-close]')) {
        e.preventDefault();
        closeDrawer();
      }
    });

    on(document, 'keydown', function(e) {
      if (e.key === 'Escape' && isOpen) closeDrawer();
      else if (isOpen) trapTab(e);
    });

    /* Open via global event (PDP add-to-cart will dispatch this) */
    on(document, 'cart:open', openDrawer);

    on(document, 'cart:item-added', function() {
      /* Phase 20 — 10ms haptic pulse on successful add. Matches
         Eight Sleep / Plunge mobile feel. No-op when the Vibration
         API isn't available (iOS Safari) or when reduced-motion
         is requested (treat as a motion signal). */
      if ('vibrate' in navigator
          && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        try { navigator.vibrate(10); } catch (err) {}
      }
      refreshDrawer().then(openDrawer);
    });

    /* Bettr Protect second-chance attach — add the warranty variant, then refresh */
    on(document, 'click', function(e) {
      var pbtn = e.target.closest('[data-cart-protect-add]');
      if (!pbtn) return;
      e.preventDefault();
      var vid = pbtn.getAttribute('data-variant-id');
      if (!vid || pbtn.disabled) return;
      pbtn.disabled = true;
      var addUrl = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        /* 2026-08-21 — `properties._addon_type` is what the orphan sweep in
           custom-bettr-addons.js identifies an add-on by. Omitting it here made
           this warranty read as a PARENT line: it survived the sauna being
           removed, AND it kept the sweep from ever cleaning the assembly and
           shower lines that were tagged correctly. */
        body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1, properties: { _addon_type: 'warranty' } }] })
      }).then(function(r){ return r.json(); }).then(function(){
        return refreshDrawer();
      }).then(function(){
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }).catch(function(){ pbtn.disabled = false; });
    });

    /* Header cart link → open drawer (intercept clicks globally via delegation) */
    on(document, 'click', function(e) {
      var trigger = e.target.closest('.custom-header__cart-link, [data-cart-drawer-open]');
      if (!trigger) return;
      e.preventDefault();
      openDrawer();
    });

    /* ── Line-item actions (event delegation survives HTML swaps) ── */
    /* Optimistic updates: qty number + minus/trash swap happen instantly,
       server sync + subtotal refresh happen in background. */
    on(panel, 'click', function(e) {
      var btn = e.target.closest('[data-qty-action]');
      if (!btn) return;
      e.preventDefault();
      var item = btn.closest('[data-item-key]');
      if (!item) return;
      var key = item.getAttribute('data-item-key');
      var action = btn.getAttribute('data-qty-action');
      var qtyValue = item.querySelector('[data-qty-value]');
      var current = parseInt(qtyValue.textContent, 10) || 0;
      var newQty;
      if (action === 'remove') newQty = 0;
      else if (action === 'increase') newQty = current + 1;
      else if (action === 'decrease') newQty = Math.max(0, current - 1);
      else return;

      /* Optimistic: update qty display instantly. Swap trash↔minus locally
         so the icon change also feels immediate. */
      if (newQty > 0) {
        qtyValue.textContent = newQty;

        var leftBtn = item.querySelector('.cart-drawer__qty-btn--remove, .cart-drawer__qty-btn--decrease');
        if (leftBtn) {
          var shouldBeDecrease = newQty > 1;
          var isDecrease = leftBtn.classList.contains('cart-drawer__qty-btn--decrease');
          if (shouldBeDecrease !== isDecrease) {
            var svg;
            if (shouldBeDecrease) {
              leftBtn.className = 'cart-drawer__qty-btn cart-drawer__qty-btn--decrease';
              leftBtn.setAttribute('data-qty-action', 'decrease');
              leftBtn.setAttribute('aria-label', 'Decrease quantity');
              svg = '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 12H19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
            } else {
              leftBtn.className = 'cart-drawer__qty-btn cart-drawer__qty-btn--remove';
              leftBtn.setAttribute('data-qty-action', 'remove');
              leftBtn.setAttribute('aria-label', 'Remove from cart');
              svg = '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.76256 2.76256C9.09075 2.43437 9.53587 2.25 10 2.25H14C14.4641 2.25 14.9092 2.43437 15.2374 2.76256C15.5656 3.09075 15.75 3.53587 15.75 4V6.25H20C20.4142 6.25 20.75 6.58579 20.75 7C20.75 7.41421 20.4142 7.75 20 7.75H19.6984L18.8811 19.1952C18.8317 19.889 18.5212 20.5384 18.0123 21.0124C17.5033 21.4865 16.8335 21.75 16.138 21.75H7.86202C7.16646 21.75 6.49673 21.4865 5.98773 21.0124C5.47878 20.5384 5.16833 19.8892 5.1189 19.1954L4.30164 7.75H4C3.58579 7.75 3.25 7.41421 3.25 7C3.25 6.58579 3.58579 6.25 4 6.25H8.25V4C8.25 3.53587 8.43437 3.09075 8.76256 2.76256ZM9.75 6.25H14.25V4C14.25 3.9337 14.2237 3.87011 14.1768 3.82322C14.1299 3.77634 14.0663 3.75 14 3.75H10C9.9337 3.75 9.87011 3.77634 9.82322 3.82322C9.77634 3.87011 9.75 3.9337 9.75 4V6.25ZM5.80546 7.75L6.6151 19.0886C6.63754 19.4039 6.77867 19.6993 7.01004 19.9147C7.2414 20.1302 7.54582 20.25 7.862 20.25H16.138C16.4542 20.25 16.7586 20.1302 16.99 19.9147C17.2213 19.6993 17.3624 19.4041 17.3849 19.0888L18.1945 7.75H5.80546ZM10 10.25C10.4142 10.25 10.75 10.5858 10.75 11V17C10.75 17.4142 10.4142 17.75 10 17.75C9.58579 17.75 9.25 17.4142 9.25 17V11C9.25 10.5858 9.58579 10.25 10 10.25ZM14 10.25C14.4142 10.25 14.75 10.5858 14.75 11V17C14.75 17.4142 14.4142 17.75 14 17.75C13.5858 17.75 13.25 17.4142 13.25 17V11C13.25 10.5858 13.5858 10.25 14 10.25Z" fill="currentColor"/></svg>';
            }
            leftBtn.innerHTML = svg;
          }
        }
      } else {
        /* Removal: fade the row out while server confirms */
        item.classList.add('is-loading');
      }

      /* Skeleton the values that refreshDrawer will soon replace.
         The line price and subtotal are computed server-side from the
         new qty — they'll look wrong until the Sections API response
         lands (typically 200-500ms). Shimmer instead of flashing
         stale-then-fresh. refreshDrawer's innerHTML swap naturally
         clears these classes on success. */
      var linePriceEl = item.querySelector('.cart-drawer__item-price');
      var subtotalEl = section.querySelector('[data-cart-subtotal]');
      if (newQty > 0) {
        if (linePriceEl) linePriceEl.classList.add('bettr-skeleton');
        if (subtotalEl) subtotalEl.classList.add('bettr-skeleton');
      } else {
        /* Removal still skeletons the subtotal (server recalc) */
        if (subtotalEl) subtotalEl.classList.add('bettr-skeleton');
      }

      /* Background: server sync + full rerender to update the subtotal.
         If it fails, revert the optimistic change + clear skeletons. */
      var clearSkeletons = function() {
        if (linePriceEl) linePriceEl.classList.remove('bettr-skeleton');
        if (subtotalEl) subtotalEl.classList.remove('bettr-skeleton');
      };
      changeLineItem(key, newQty).then(function(result) {
        if (result) {
          /* /cart/change.js already answered with the whole updated cart, so
             hand it straight to the refresh instead of fetching /cart.js again
             for the same bytes. `true` means the change succeeded but the body
             wasn't usable — refresh fetches normally in that case. */
          refreshDrawer(result === true ? null : result);
        } else {
          qtyValue.textContent = current;
          item.classList.remove('is-loading');
          clearSkeletons();
        }
      }).catch(function() {
        qtyValue.textContent = current;
        item.classList.remove('is-loading');
        clearSkeletons();
      });
    });

    /* ── AJAX helpers ──
       Phase 17: wrap mutations in a Web Lock so two tabs can't race.
       BettrCrossTab.withLock is a no-op when the API is missing. */
    function changeLineItem(key, quantity) {
      /* Global progress cursor during the server sync window.
         Paired with the optimistic UI + skeletons, this communicates
         "work in progress" via the CSS html.is-busy * { cursor: progress }
         rule in layout/theme.liquid. */
      document.documentElement.classList.add('is-busy');
      var clearBusy = function() {
        document.documentElement.classList.remove('is-busy');
      };
      var doFetch = function() {
        return fetch(window.routes.cart_change_url + '.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ id: key, quantity: quantity })
        }).then(function(r) {
          clearBusy();
          if (!r.ok) return null;
          /* Resolve with the updated cart so the caller can skip a second
             fetch. `true` = the change worked but the body didn't parse. */
          return r.json().catch(function() { return true; });
        }, function(err) {
          clearBusy();
          throw err;
        });
      };
      if (window.BettrCrossTab && typeof window.BettrCrossTab.withLock === 'function') {
        return window.BettrCrossTab.withLock('bettr-cart-mutation', doFetch);
      }
      return doFetch();
    }

    /* Local money formatter for the fast-path subtotal update.
       Matches Liquid's `| money_without_trailing_zeros` output for USD. */
    function formatMoney(cents) {
      if (typeof cents !== 'number') return '';
      var n = Math.round(cents) / 100;
      var parts = n.toFixed(2).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (parts[1] === '00') return '$' + parts[0];
      return '$' + parts.join('.');
    }

    /* AbortControllers so rapid qty clicks don't leave stale fetches winning
       the race. Each new fetch aborts the previous one. */
    var subtotalAbort = null;
    var refreshAbort = null;

    /* Fast path: update count + subtotal in the DOM immediately from /cart.js.
       Runs in parallel with the slower Section API render, so the subtotal
       doesn't lag behind the qty number or the cart badge. */
    function fastSubtotalSync(knownCart) {
      /* When the caller already holds the updated cart (every /cart/change.js
         response is one), apply it directly. Saves a whole round trip per
         quantity click — three requests became two. */
      var source;
      /* Cancel any in-flight sync either way. A known cart is applied
         immediately, so an older fetch still on the wire would land afterwards
         and overwrite the fresh subtotal with a stale one — reachable by adding
         to cart and then changing a quantity before the add's sync returns. */
      if (subtotalAbort) subtotalAbort.abort();
      if (knownCart) {
        source = Promise.resolve(knownCart);
      } else {
        subtotalAbort = new AbortController();
        source = fetch(window.routes.cart_url + '.js', { headers: { 'Accept': 'application/json' }, signal: subtotalAbort.signal })
          .then(function(r) { return r.json(); });
      }
      return source
        .then(function(cart) {
          var subtotalEl = section.querySelector('[data-cart-subtotal]');
          if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
          if (body) body.setAttribute('data-cart-count', String(cart.item_count));
          var headerBadge = document.querySelector('.custom-header__cart-count');
          if (headerBadge) {
            if (cart.item_count > 0) {
              headerBadge.textContent = cart.item_count;
              headerBadge.style.display = '';
            } else {
              headerBadge.style.display = 'none';
            }
          } else if (cart.item_count > 0) {
            var cartLink = document.querySelector('.custom-header__cart-link');
            if (cartLink) {
              var span = document.createElement('span');
              span.className = 'custom-header__cart-count';
              span.textContent = cart.item_count;
              cartLink.appendChild(span);
            }
          }
          /* Return the cart object so refreshDrawer can pass it through
             the cart:updated event detail — saves consumers (validateCart
             in custom-bettr-addons, the cross-tab listener) a redundant
             /cart.js fetch. */
          return cart;
        })
        .catch(function(err) {
          /* AbortError is expected when a newer fetch supersedes this one. */
          if (err && err.name === 'AbortError') return null;
          /* Silent otherwise; authoritative section render will sync.
             Return null so cart:updated falls back to a detail-less
             dispatch and consumers fetch normally. */
          return null;
        });
    }

    function refreshDrawer(knownCart) {
      /* Kick off the fast subtotal/count sync in parallel and capture
         its promise so we can include the cart object in the cart:updated
         event detail below — saves listeners a redundant /cart.js fetch.
         `knownCart`, when the caller already has one, saves the fetch too. */
      var cartPromise = fastSubtotalSync(knownCart);

      if (refreshAbort) refreshAbort.abort();
      refreshAbort = new AbortController();

      /* NOTE: no Accept header — on /products/* URLs, Accept: application/json
         routes to the .js product endpoint instead of the Sections API. */
      var url = window.location.pathname + '?sections=' + sectionId + '&t=' + Date.now();
      return fetch(url, { signal: refreshAbort.signal })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var html = data[sectionId];
          if (!html) return;
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newBody = doc.querySelector('[data-cart-body]');
          var newFooter = doc.querySelector('[data-cart-footer]');

          if (newBody && body) body.innerHTML = newBody.innerHTML;
          if (newFooter && footer) {
            footer.innerHTML = newFooter.innerHTML;
            if (newFooter.hasAttribute('hidden')) footer.setAttribute('hidden', '');
            else footer.removeAttribute('hidden');
          }
          /* Announce cart-count change to screen readers via the live region.
             The count travels as a data-cart-count attribute on [data-cart-body] —
             there is no visible count element. */
          var liveEl = section.querySelector('[data-cart-live]');
          var liveN = newBody ? parseInt(newBody.getAttribute('data-cart-count'), 10) : NaN;
          if (liveEl && !isNaN(liveN)) {
            if (body) body.setAttribute('data-cart-count', String(liveN));
            liveEl.textContent = liveN === 0
              ? 'Cart is empty.'
              : (liveN === 1 ? '1 item in your cart.' : liveN + ' items in your cart.');
          }

          /* Notify validators (e.g. add-on orphan cleanup) that the cart
             changed. Wait for the parallel /cart.js sync to land so we can
             pass the cart in the event detail — when consumers see
             detail.cart they skip their own redundant /cart.js fetch.
             Falls back to a detail-less dispatch if the fast sync errored
             (consumers then fetch normally). */
          cartPromise.then(function(cart) {
            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: cart ? { cart: cart } : {}
            }));
          });

          /* Sync header cart badge.
             2026-09-04 — this block used to test `newCount`, a name declared
             nowhere in the file. Reading it threw a ReferenceError on EVERY
             refresh, swallowed by the .catch() below, so the block had never
             run once. It matters when the parallel /cart.js sync above fails
             or is superseded: that is the only other thing that syncs the
             badge, and without this the header kept showing the old count
             while the drawer showed the new one. The count is already parsed
             out of the rendered section as `liveN` — use it. */
          if (!isNaN(liveN)) {
            var n = liveN;
            var headerBadge = document.querySelector('.custom-header__cart-count');
            if (headerBadge) {
              if (n > 0) {
                headerBadge.textContent = n;
                headerBadge.style.display = '';
              } else {
                headerBadge.style.display = 'none';
              }
            } else if (n > 0) {
              /* Badge didn't exist (cart was empty) — create it */
              var cartLink = document.querySelector('.custom-header__cart-link');
              if (cartLink) {
                var span = document.createElement('span');
                span.className = 'custom-header__cart-count';
                span.textContent = n;
                cartLink.appendChild(span);
              }
            }
          }
        })
        .catch(function(err) {
          if (err && err.name === 'AbortError') return;
          /* Silent; a later refresh or the optimistic DOM update covers the UI. */
        });
    }

    /* Refresh + reopen when the add-on validator removes orphaned line items */
    on(document, 'cart:cleaned', function() {
      refreshDrawer();
    });

    /* 2026-10-27 — that validator (custom-bettr-addons.js) loads only on product pages and the
       cart page. Everywhere else, removing the sauna here left its warranty and assembly in a
       checkout-able cart. Same rule as the validator: no sauna left, the add-ons go. */
    on(document, 'cart:updated', function(e) {
      if (window.BettrAddons) return;
      var cart = e.detail && e.detail.cart;
      if (!cart || !cart.items || !cart.items.length) return;
      var hasParent = cart.items.some(function(i) { return !i.properties || !i.properties._addon_type; });
      if (hasParent) return;
      var updates = {};
      cart.items.forEach(function(i) { updates[i.key] = 0; });
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin',
        body: JSON.stringify({ updates: updates })
      })
        .then(function(r) { if (r.ok) refreshDrawer(); })
        .catch(function() {});
    });

    /* Cleanup on section unload (Theme Editor re-renders) */
    document.addEventListener('shopify:section:unload', function(e) {
      if (!section || !e.target || !e.target.contains(section)) return;
      if (isOpen) closeDrawer();
      if (subtotalAbort) { try { subtotalAbort.abort(); } catch (err) {} }
      if (refreshAbort) { try { refreshAbort.abort(); } catch (err) {} }
      teardown.forEach(function(fn) { try { fn(); } catch (err) {} });
      teardown.length = 0;
    }, { once: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var header = document.querySelector('.custom-header');
    if (!header) return;
    var section = header.closest('.shopify-section');
    if (!section) return;

    var toggle = section.querySelector('.custom-header__menu-toggle');
    var drawer = section.querySelector('.custom-header__drawer');
    var backdrop = section.querySelector('.custom-header__drawer-backdrop');

    if (!toggle || !drawer) return;

    /* Track teardown so section-reload in the editor doesn't leak listeners. */
    var teardown = [];
    function on(target, event, handler, opts) {
      target.addEventListener(event, handler, opts);
      teardown.push(function() { target.removeEventListener(event, handler, opts); });
    }

    /* Scroll lock is handled centrally in layout/theme.liquid via a :has()
       rule that watches for `.custom-header__drawer[aria-hidden="false"]`
       and sets overflow:hidden on <html>+<body>. No JS work needed here. */

    /* Focus trap inside the drawer */
    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
    function trap(e) {
      if (e.key !== 'Tab') return;
      var nodes = drawer.querySelectorAll(FOCUSABLE);
      if (!nodes.length) return;
      var first = nodes[0];
      var last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    var lastFocused = null;

    /* Apply `inert` to background siblings of the drawer so AT users + tab-
       cycling can't reach the rest of the page while the drawer is open.
       Header is intentionally NOT inerted — the drawer is its open-state child
       and the focus trap already constrains keyboard nav to the panel.
       `drawer.contains(el)` is a defensive guard (drawer is not inside main/
       footer in practice, but keeps the helper robust to layout changes). */
    function setBackgroundInert(on) {
      var nodes = document.querySelectorAll('main, footer, .custom-footer-section');
      Array.prototype.forEach.call(nodes, function (el) {
        if (drawer.contains(el)) return;
        if (on) el.setAttribute('inert', '');
        else el.removeAttribute('inert');
      });
    }

    function openDrawer() {
      lastFocused = document.activeElement;
      toggle.setAttribute('aria-expanded', 'true');
      drawer.setAttribute('aria-hidden', 'false');
      setBackgroundInert(true);
      var firstLink = drawer.querySelector(FOCUSABLE);
      if (firstLink) firstLink.focus();
    }

    function closeDrawer() {
      setBackgroundInert(false);
      toggle.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    on(toggle, 'click', function() {
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      if (isOpen) closeDrawer(); else openDrawer();
    });

    /* Dedicated close button inside the drawer top bar */
    var drawerCloseBtn = section.querySelector('[data-drawer-close]');
    if (drawerCloseBtn) on(drawerCloseBtn, 'click', closeDrawer);

    if (backdrop) on(backdrop, 'click', closeDrawer);

    on(drawer, 'keydown', trap);

    on(document, 'keydown', function(e) {
      if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') closeDrawer();
    });

    /* Close desktop <details> dropdowns on outside click */
    on(document, 'click', function(e) {
      var dropdowns = section.querySelectorAll('.custom-header__dropdown');
      dropdowns.forEach(function(dropdown) {
        if (!dropdown.contains(e.target) && dropdown.open) dropdown.open = false;
      });
    });

    /* Esc closes any open desktop dropdown (mega or plain) */
    on(document, 'keydown', function(e) {
      if (e.key !== 'Escape') return;
      var openDropdown = section.querySelector('.custom-header__dropdown[open]');
      if (openDropdown) {
        openDropdown.open = false;
        var summary = openDropdown.querySelector('summary');
        if (summary) summary.focus();
      }
    });

    /* Auto-submit localization form on currency change (topbar flag
       picker). */
    var locForms = section.querySelectorAll('.custom-header__drawer-topbar-loc');
    locForms.forEach(function(locForm) {
      var locSelect = locForm.querySelector('select');
      if (locSelect) on(locSelect, 'change', function() { locForm.submit(); });
    });

    /* Hover-intent for mega menus (desktop pointer devices only).
       80ms open delay debounces sweep-through; 150ms close delay
       gives a forgiving grace zone when moving diagonally into the panel. */
    var hoverEnabled = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var megaDropdowns = section.querySelectorAll('.custom-header__dropdown--mega');
    megaDropdowns.forEach(function(dd) {
      var openTimer = null;
      var closeTimer = null;
      function clearTimers() {
        if (openTimer) { clearTimeout(openTimer); openTimer = null; }
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      }

      if (hoverEnabled) {
        on(dd, 'mouseenter', function() {
          clearTimers();
          openTimer = setTimeout(function() { dd.open = true; }, 80);
        });
        on(dd, 'mouseleave', function() {
          clearTimers();
          closeTimer = setTimeout(function() { dd.open = false; }, 150);
        });
      }

      /* Keyboard: open when summary or any descendant gets focus,
         close when focus leaves the entire dropdown. */
      on(dd, 'focusin', function() {
        clearTimers();
        dd.open = true;
      });
      on(dd, 'focusout', function(e) {
        if (dd.contains(e.relatedTarget)) return;
        clearTimers();
        closeTimer = setTimeout(function() { dd.open = false; }, 150);
      });
    });

    /* ── Announcement bar show/hide on scroll direction (rAF throttled) ── */
    var announcementSection = document.querySelector('.custom-announcement-bar-section');
    if (announcementSection) {
      var lastScrollY = window.scrollY;
      var scrollUpAccum = 0, scrollDownAccum = 0;
      var isHidden = false;
      var deadZone = 3;
      var scrollPending = false;

      function processScroll() {
        scrollPending = false;
        var currentScrollY = window.scrollY;
        var delta = currentScrollY - lastScrollY;
        lastScrollY = currentScrollY;

        if (Math.abs(delta) < deadZone) return;

        var isMobile = window.innerWidth < 750;
        var showThreshold = isMobile ? 240 : 120;
        var hideThreshold = isMobile ? 100 : 200;

        if (delta > 0) {
          scrollUpAccum = 0;
          scrollDownAccum += delta;
          if (scrollDownAccum >= hideThreshold && !isHidden) {
            announcementSection.classList.add('is-hidden');
            isHidden = true;
            scrollDownAccum = 0;
          }
        } else {
          scrollDownAccum = 0;
          scrollUpAccum += Math.abs(delta);
          if (scrollUpAccum >= showThreshold && isHidden) {
            announcementSection.classList.remove('is-hidden');
            isHidden = false;
            scrollUpAccum = 0;
          }
        }

        if (currentScrollY <= 10 && isHidden) {
          announcementSection.classList.remove('is-hidden');
          isHidden = false;
          scrollUpAccum = 0;
          scrollDownAccum = 0;
        }
      }

      on(window, 'scroll', function() {
        if (scrollPending) return;
        scrollPending = true;
        window.requestAnimationFrame(processScroll);
      }, { passive: true });
    }

    /* Cleanup on section unload (Theme Editor re-renders) */
    document.addEventListener('shopify:section:unload', function(e) {
      if (!section || !e.target || !e.target.contains(section)) return;
      if (toggle.getAttribute('aria-expanded') === 'true') closeDrawer();
      teardown.forEach(function(fn) { try { fn(); } catch (err) {} });
      teardown.length = 0;
    }, { once: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
